import './proto/string.js';
import './proto/hfy.js';
import './proto/customrendertags.js';

(function($, root) {
  "use strict";

  $.onloadWithTimeout = function(callback) {
    //do the following stuff right after everything (including images ) are loaded to page, or timeout

    //after everything is loaded:
    $(window).on("load", function() {
      if (!window.rdo.loader.loaded) {
        callback();
      }
    });

    setTimeout(function() {
      if (!window.rdo.loader.loaded) {
        callback();
      }
    }, window.rdo.loader.timeout);

  };

  $.onresizeWithTimeout = function(callback) {
    //do the following stuff right after everything (including images ) are loaded to page, or timeout

    var timeoutResize;
    timeoutResize = setTimeout(function() {
      callback();
    }, 200);

    $(window)
      .resize(function(event) {
        clearTimeout(timeoutResize);
        $(window)
          .checkScreen();
        timeoutResize = setTimeout(function() {
          callback();
        }, window.rdo.loader.timeout);
      })
      .trigger('resize');

  };

  $.fn.extend({

    checkScreen: function() {

      window.rdo.page.pagewidth = $(this).width();
      window.rdo.page.pageheight = $(this).height();

      switch (true) {
        case (window.rdo.page.pagewidth < 577):
          window.rdo.page.orientation = 'smartphone';

          // window.rdo.carousel.timeout = 3000;
          break;
        case (window.rdo.page.pagewidth < 769):
          window.rdo.page.orientation = 'lanscape-smartphone';

          break;
        case (window.rdo.page.pagewidth < 993):
          window.rdo.page.orientation = 'medium';

          break;
        case (window.rdo.page.pagewidth < 1201):
          window.rdo.page.orientation = 'large';

          break;
        case (window.rdo.page.pagewidth < 1367):
          window.rdo.page.orientation = 'xlarge';

          break;
        default:
          window.rdo.page.orientation = 'xxlarge';

      }

      if (
        (navigator.appVersion.indexOf("MSIE 10") !== -1) // ie 10
        ||
        (!!window.MSInputMethodContext && !!document.documentMode) //ie 11

      ) {
        window.rdo.ie = true;
        $('html').addClass('ie');
      }

      if (window.navigator.userAgent.indexOf("Edge") > -1) {
        window.rdo.edge = true;
        $('html').addClass('edge');

      }

      if (window.navigator.userAgent.match(/iPad/i) || window.navigator.userAgent.match(/iPhone/i)) {
        window.rdo.mobileSafari = true;
        $('html').addClass('mobile-safari');
        // iPad or iPhone
      }

      var md = new MobileDetect(window.navigator.userAgent);
      if (md.mobile()) {
        $('body').addClass('isMobile');
        if (window.rdo.page.orientation == 'smartphone') {
          $('body').addClass('portrait');

          if (window.rdo.loader.introdone) {
            $.pauseTimer();
          }else {
            // if (window.rdo.video.tv) {
            //   window.rdo.video.tv.stopVideo();
            //   window.rdo.video.tv = null;
            // }
          }
        } else {
          $('body').removeClass('portrait');

          if (!window.rdo.loader.introdone) {
            //TODO:
            //here, not waiting until page is loaded.

            $.startPage();
          } else {
            // if (!window.rdo.index.shown) {
            //   $.continueTimer();
            // }

          }

        }
        window.rdo.isMobile = true;
        window.rdo.clickevent = 'click';

        // $('.banner').show();

        // $('.copyright').html('ismobile');
        if (md.os() == 'AndroidOS') {

          window.rdo.mobileClient = 'android';
          // $('.banner a').attr('href', window.rdo.appurl.android);
          // $('.copyright').html('ismobile : android');

        }
        if (md.is('iPhone')) {
          window.rdo.mobileClient = 'ios';
          // $('.banner a').attr('href', window.rdo.appurl.ios);
          // $('.copyright').html('ismobile : iphone');

        }
        // location.href = (md.mobileGrade() === 'A') ? '/mobile/' : '/lynx/';
      } else {
        $('body').removeClass('isMobile');
        window.rdo.clickevent = 'click touchstart';
        // $('.banner').hide();
        // $('.copyright').html('not mobile');

      }

    }
  });

  $.killLoading = function() {
    $.hidePageOver();

  };

  $.showPageOver = function() {
    window.rdo.loader.pageOver.css("display", "flex").hide().fadeIn();

  }
  $.hidePageOver = function() {
    window.rdo.loader.pageOver.fadeOut();

  }

  $.fn.extend({
    animateCss: function(animationName, callback) {
      var animationEnd = (function(el) {
        var animations = {
          animation: 'animationend',
          OAnimation: 'oAnimationEnd',
          MozAnimation: 'mozAnimationEnd',
          WebkitAnimation: 'webkitAnimationEnd',
        };

        for (var t in animations) {
          if (el.style[t] !== undefined) {
            return animations[t];
          }
        }
      })(document.createElement('div'));
      // this.addClass('animated ' + animationName).one(animationEnd, function() {
      this.addClass(animationName).one(animationEnd, function() {
        console.log(animationName + ' HAS ENDED!!');
        // $(this).removeClass('animated ' + animationName);

        if (typeof callback === 'function') callback();
      });

      return this;
    },
  });

  $(window).resize(function() {
    $(window).checkScreen();
  });

  $(function() {
    'use strict';
    $.config();



    $.onloadWithTimeout(function() {
      window.rdo.loader.loaded = true;
      $.killLoading();

      $.constructPage();

    });
  });

})(jQuery, this);

import '../../config.js';
import './core/audio.js';
import './core/index.js';
import './core/modal.js';
import './core/intro.js';
import './core/animations.js';
import './core/construct.js';
import './core/contentapps.js';
import './core/render.js';
import './core/load.js';
import './core/main.js';
import './core/selections.js';
import './core/timer.js';
import './core/video_youtube.js';
// import './core/video_vimeo.js';
import './core/scrolls.js';
